import React, { useState } from 'react';
import { Modal, Button, Paper, withStyles } from '@material-ui/core';
import iconClient from './images/iconClient.png';

const styles = {
  modalStyle: {
    position: 'absolute',
    width: 391,
    height: 325,
    top: 145,
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: 'white',
    borderRadius: 24,
    padding: '20px',
    outline: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center'
  }
};

const ModalRFCNotFound = ({ classes, open, setOpen }) => {
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Modal open={open} onClose={handleClose}>
        <Paper className={classes.modalStyle}>
          <img src={iconClient} alt="Icono de cliente" style={{ width: '100px', height: '100px' }} />
          <span
            style={{ fontFamily: 'Sura Sans', fontSize: '22px', color: '#0033A0', fontWeight: 600, marginTop: '10px' }}
          >
            El RFC no es Correcto
          </span>
          <span style={{ fontFamily: 'Sura Sans', fontSize: '16px', color: '#0033A0', textAlign: 'left',marginTop: '7px' }}>
          Estimado Usuario, el RFC no está asociado a la póliza. También puede llamar al Call Center para realizar su pago Tel 55 5723 7999          </span>
          <div
            onClick={handleClose}
            style={{
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '92px',
              height: '40px',
              borderRadius: '28px',
              border: '1px solid #0133A0',
              fontFamily: 'Sura Sans',
              fontSize: '16px',
              color: '#0133A0',
              justifySelf:'flex-end',
              marginTop: 'auto'
            }}
          >
            Regresar
          </div>
        </Paper>
      </Modal>
    </div>
  );
};

export default withStyles(styles)(ModalRFCNotFound);



// WEBPACK FOOTER //
// ./src/containers/client/ModalRFCNotFound.js